import { BaseProductTile } from '../base/BaseProductTile';
import React from 'react';
import { Place } from '@model/iceberg';
import { Result } from '@model/iceberg/deal-finder/deal-finder';
import { Amount, BoardBasisSearch } from '@model/common';
import { Price } from './price/Price';
import { DestinationLink } from '@components/common/next-link';
import { FILTER_DEFAULTS } from '@model/price-calendar';
import { UrlSearchParams } from '@model/iceberg/deal-finder/deal-finder';
import { ZERO_PRICE_VALUE } from '@model/iceberg/common/zero-price';
import { OfferType } from '@model/offers/offers';
import { getDefaultSearchMonth } from '@util/date-time';

export interface FromPriceProductTileProps {
  testFlag?: boolean;
  testId?: string;
  productPackage: Result;
  className?: string;
  offerType?: OfferType;
}

export const FromPriceProductTile = (props: FromPriceProductTileProps) => {
  const { productPackage, offerType } = props;
  const { leadInPrice, summary } = productPackage;
  const { mealPlan } = leadInPrice;
  const { startDate } = summary;
  const cheapestPrice = leadInPrice?.perPerson?.amount;
  const amount: Amount = new Amount(cheapestPrice, leadInPrice?.perPerson?.currency.code);
  const place: Place = productPackage.summary.place;
  let urlParamsString: string = '';
  if (offerType) {
    const [checkInYear, checkInMonth] = startDate.split('-');
    const [defaultYear, defaultMonth] = getDefaultSearchMonth().split('-');

    const urlParams: UrlSearchParams = {
      year: !isNaN(parseInt(checkInYear)) ? checkInYear : defaultYear,
      month: !isNaN(parseInt(checkInMonth)) ? checkInMonth : defaultMonth,
      boardBasis: BoardBasisSearch[mealPlan],
      duration: productPackage.summary.nights.toString(),
      adults: offerType === OfferType.NO_SINGLE_SUPPLEMENT ? '1' : `${FILTER_DEFAULTS.occupancy[0].adults}`
    };

    urlParamsString = new URLSearchParams(urlParams as any).toString();
  }

  return (
    <DestinationLink path={place.hotel!.path} urlParams={urlParamsString}>
      <BaseProductTile
        {...props}
        renderPrice={cheapestPrice && cheapestPrice !== ZERO_PRICE_VALUE ? <Price amount={amount} /> : null}
        boardBasis={mealPlan}
      />
    </DestinationLink>
  );
};
